import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup } from '@telus-uds/components-web';

import { useLocaleContext } from '../../../context/LocaleContext';
import EN from '../../../../EN.json';
import FR from '../../../../FR.json';

const DefectPriority = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const locale = useLocaleContext();
  const {
    reportIssue: {
      form: {
        labelPriority,
        labelPriorityOptionLow,
        labelPriorityOptionMedium,
        labelPriorityOptionHigh,
        labelPriorityOptionUrgent
      }
    }
  } = locale === 'en-US' ? EN : FR;

  const fieldError = 'priority' in formErrors;
  const fieldOptions = [
    labelPriorityOptionLow,
    labelPriorityOptionMedium,
    labelPriorityOptionHigh,
    labelPriorityOptionUrgent
  ];

  // Convert options to RadioGroup items format: { label, id }
  const items = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  const handleSelect = (value) => {
    if (value) {
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.priority;
        return updatedValues;
      });
      setFieldData(previousValue => ({
        ...previousValue,
        priority: value
      }));
    }
  };

  return (
    <div>
      <RadioGroup
        legend={`${labelPriority} *`}
        items={items}
        checkedId={fieldData.priority || null}
        onChange={handleSelect}
        name="priority"
        validation={fieldError ? 'error' : undefined}
        feedback={fieldError ? formErrors.priority.message : undefined}
      />
    </div>
  );
};

DefectPriority.propTypes = {
  formErrors: PropTypes.shape({
    priority: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectPriority;
